import { useEffect, useRef } from "react";
import { checkNetworkStability, offline, online } from "./utils/utilties";

const MonitorNetwork = () => {

    const ping = useRef<ReturnType<typeof setInterval> | null>(null)

    useEffect(() => {
        ping.current = checkNetworkStability();
        window.addEventListener("online", online);
        window.addEventListener("offline", offline)

        return () => {
            if (ping?.current) {
                clearInterval(ping.current)
            }
            else {
                /* do nothing */
            }
            window.removeEventListener("online", online);
            window.removeEventListener("offline", offline)
        }
    }, [])

    return null
}

export default MonitorNetwork